module.exports = __webpack_public_path__ + "media/App/tradertax-31a795ff14f2b801850658fdee83c14f.png";